import { SvelteMap } from "svelte/reactivity";
import {} from "./float.js";
function initFloatManager() {
    const activeComponents = new SvelteMap();
    const dynamicElements = $derived(Array.from(activeComponents.values()).filter((component) => component.type === "dynamic"));
    const staticElements = $derived(Array.from(activeComponents.values()).filter((component) => component.type === "static"));
    function addFloatElement(layer, options) {
        activeComponents.set(layer, options);
    }
    function closeFloatElementByLayer(layer = 1) {
        if (!activeComponents.delete(`layer_${layer}`)) {
            console.warn("Couldn't find float element with layer id: ", `layer_${layer}`);
        }
    }
    function isElementActive(id) {
        return Array.from(activeComponents.values()).some((component) => component.id === id);
    }
    function getLayerFromID(id) {
        return Array.from(activeComponents.values()).find((component) => component.id === id)?.layer;
    }
    return {
        addFloatElement,
        closeFloatElementByLayer,
        get activeElements() {
            return [...activeComponents.entries()];
        },
        get dynamicElements() {
            return dynamicElements;
        },
        get staticElements() {
            return staticElements;
        },
        isElementActive,
        getLayerFromID
    };
}
export const floatManager = initFloatManager();
export const floatManagerUtils = {
    close: (layer = 1) => {
        floatManager.closeFloatElementByLayer(layer);
    }
};
